/**
 * Las pantallas de antes de iniciar sesión.
 *
 * `Bienvenido` agrees masculine and this line names the person reading it, so the greeting is written
 * as `Le damos la bienvenida` — a verb phrase, which is gender-free. Every other string here is
 * gender-free already. The same care is taken on the QR page (`Ingresó como`, not `Identificado`).
 *
 * USTED THROUGHOUT, and consistently. This application talks to a person about their own employer's
 * records; `tú` reads as an app talking down to a grown man. The QR page made the same choice.
 *
 * `contraseña`, never `clave` or `password`. All three are heard on a job site, but `contraseña` is
 * what Android, iOS and every bank in Mexico print, so it is the one word a reader has certainly met
 * before.
 */
export default {
  // ── iniciar sesión ────────────────────────────────────────────────────────────────────────────
  welcomeBack: 'Le damos la bienvenida',
  signInToAccess: (name) => `Inicie sesión para entrar a ${name}`,
  emailAddress: 'Correo electrónico',
  emailPlaceholder: 'Escriba su correo del trabajo',
  password: 'Contraseña',
  passwordPlaceholder: 'Escriba su contraseña',
  forgotPassword: '¿Olvidó su contraseña?',
  signIn: 'Iniciar sesión',
  signingIn: 'Iniciando sesión…',
  signInFailed: 'No se pudo iniciar sesión',
  checkEmailAndPassword: 'Revise su correo y su contraseña e intente otra vez.',
  emailRequired: 'Falta el correo electrónico',
  emailInvalid: 'Escriba un correo electrónico válido',
  passwordRequired: 'Falta la contraseña',
  needHelp: '¿Necesita ayuda?',
  contactAdministrator: 'Hable con su administrador',

  // ── se le olvidó la contraseña: pedir el enlace ───────────────────────────────────────────────
  resetTitle: 'Cambiar su contraseña',
  resetSubtitle: 'Escriba su correo electrónico y le mandamos un enlace para cambiarla',
  resetEmailPlaceholder: 'Escriba su correo electrónico',
  sendResetLink: 'Mandar el enlace',
  sending: 'Mandando…',
  resetLinkSent: 'Ya se mandó el enlace',
  resetLinkSentBody: 'Revise su correo electrónico. Ahí está el enlace para cambiar su contraseña.',

  // ── se le olvidó la contraseña: poner la nueva ────────────────────────────────────────────────
  setNewPasswordTitle: 'Ponga una contraseña nueva',
  setNewPasswordSubtitle: 'Escriba abajo su contraseña nueva',
  newPassword: 'Contraseña nueva',
  newPasswordPlaceholder: 'Escriba su contraseña nueva',
  confirmNewPassword: 'Repita la contraseña nueva',
  confirmNewPasswordPlaceholder: 'Escriba otra vez la contraseña nueva',
  resetPassword: 'Cambiar la contraseña',
  resetting: 'Cambiando…',
  resetSucceededTitle: 'Ya se cambió su contraseña',
  resetSucceededBody: 'Su contraseña quedó cambiada. Lo llevamos al inicio de sesión…',
  resetSucceededSignInNow: 'Su contraseña quedó cambiada. Inicie sesión con la contraseña nueva.',
  newPasswordRequired: 'Falta la contraseña nueva',
  passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
  confirmYourPassword: 'Repita la contraseña',
  passwordsDoNotMatch: 'Las contraseñas no son iguales',
  backToSignIn: 'Volver a iniciar sesión',
  error: 'Error',
}
